class L4MReviewsHub {
  constructor(root) {
    this.root = root;
    this.country = root.querySelector('[data-rh-country]');
    this.product = root.querySelector('[data-rh-product]');
    this.language = root.querySelector('[data-rh-language]');
    this.items = [...root.querySelectorAll('[data-rh-item]')];
    this.partnerItems = [...root.querySelectorAll('[data-rh-partner]')];
    this.marketButton = root.querySelector('[data-rh-market-filter]');
    this.emptyStates = [...root.querySelectorAll('[data-rh-empty]')];
    this.populate(this.country, 'country');
    this.populate(this.product, 'product');
    this.populate(this.language, 'language');
    [this.country, this.product, this.language].forEach(el => el && el.addEventListener('change', () => this.apply()));
    this.marketButton?.addEventListener('click', () => this.filterToMarket());
    this.setupRails();
    this.apply();
  }
  populate(select, key) {
    if (!select) return;
    const values = new Map();
    this.items.forEach(item => {
      const raw = (item.dataset[key] || '').trim();
      raw.split('|').map(v => v.trim()).filter(Boolean).forEach(v => values.set(v.toLowerCase(), v));
    });
    this.partnerItems.forEach(item => {
      if (key !== 'country') return;
      const raw = (item.dataset.country || '').trim();
      raw.split('|').map(v => v.trim()).filter(Boolean).forEach(v => values.set(v.toLowerCase(), v));
    });
    [...values.values()].sort((a,b)=>a.localeCompare(b)).forEach(v => {
      if ([...select.options].some(o => o.value.toLowerCase() === v.toLowerCase())) return;
      const o=document.createElement('option'); o.value=v; o.textContent=v; select.appendChild(o);
    });
  }
  match(raw, value) {
    if (!value || value === 'all') return true;
    if (!raw) return true;
    return raw.split('|').map(v=>v.trim().toLowerCase()).includes(value.toLowerCase());
  }
  apply() {
    const c=this.country?.value || 'all', p=this.product?.value || 'all', l=this.language?.value || 'all';
    this.items.forEach(item => { item.hidden = !(this.match(item.dataset.country,c) && this.match(item.dataset.product,p) && this.match(item.dataset.language,l)); });
    this.partnerItems.forEach(item => { item.hidden = !this.match(item.dataset.country,c); });
    this.emptyStates.forEach(empty => {
      const scope = this.root.querySelector(empty.dataset.rhEmpty);
      if (!scope) return;
      const visible = [...scope.querySelectorAll('[data-rh-item]')].some(el => !el.hidden);
      empty.style.display = visible ? 'none' : 'block';
    });
  }
  setupRails() {
    this.root.querySelectorAll('[data-rh-scroll]').forEach(button => {
      button.addEventListener('click', () => {
        const section=button.closest('.l4m-rh__section');
        const rail=section?.querySelector('.l4m-rh__rail');
        if (!rail) return;
        const dir=button.dataset.rhScroll === 'prev' ? -1 : 1;
        rail.scrollBy({left:dir*Math.max(rail.clientWidth*.78,260),behavior:'smooth'});
      });
    });
  }

  filterToMarket() {
    const market=(this.marketButton?.dataset.market || '').trim();
    if (!market || !this.country) return;
    const option=[...this.country.options].find(o=>o.value.toLowerCase()===market.toLowerCase());
    if (option) { this.country.value=option.value; this.apply(); this.country.scrollIntoView({behavior:'smooth',block:'center'}); }
  }
}

document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-l4m-reviews-hub]').forEach(el=>new L4MReviewsHub(el)));
document.addEventListener('shopify:section:load',e=>{const el=e.target.querySelector?.('[data-l4m-reviews-hub]'); if(el)new L4MReviewsHub(el)});
